module.exports = __webpack_public_path__ + "static/img/fudai.c78e6f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fudai.png
// module id = C104
// module chunks = 128